import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  private expressCheckout = false;

  setExpressCheckout(status: boolean) {
    this.expressCheckout = status;
  }

  isExpressCheckout(): boolean {
    return this.expressCheckout;
  }
}
